module.exports = __webpack_public_path__ + "img/金牌.7020d737.png";